import { render, staticRenderFns } from "./EditQQGroupDialog.vue?vue&type=template&id=9b1c88a6"
import script from "./EditQQGroupDialog.vue?vue&type=script&lang=js"
export * from "./EditQQGroupDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports